import { JSX } from 'react'

import { IconProps } from '../../icon'

const Quimica: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M22.8783 28.8076C22.8783 32.5658 20.7898 35.6126 17.3513 35.6126C13.9128 35.6126 11.1255 32.5658 11.1255 28.8076H22.8783Z'
      fill='#AAD3DC'
    />
    <path
      d='M38.9196 34.3969H27.2648C26.2901 34.3969 25.7033 33.3174 26.2343 32.4999L30.0143 26.6761H36.1666L39.9501 32.4999C40.4811 33.3174 39.8944 34.3969 38.9196 34.3969Z'
      fill='#D7D861'
    />
    <path
      d='M18.7788 21.8793V14.1725H19.1255C19.7246 14.1725 20.2118 13.6853 20.2118 13.0863C20.2118 12.4873 19.7246 12 19.1255 12H12.9433C12.3443 12 11.857 12.4873 11.857 13.0863C11.857 13.6853 12.3443 14.1725 12.9433 14.1725H13.29V21.8325C10.4148 22.9383 8.5 25.7101 8.5 28.8076C8.5 32.9283 11.8523 36.2806 15.973 36.2806C20.0938 36.2806 23.4461 32.9283 23.4461 28.8076C23.4461 25.7688 21.5803 23.0156 18.7788 21.8793ZM12.5558 13.0863C12.5558 12.8725 12.7295 12.6988 12.9433 12.6988H19.1255C19.3393 12.6988 19.513 12.8725 19.513 13.0863C19.513 13.3 19.3393 13.4738 19.1255 13.4738H12.9433C12.7295 13.474 12.5558 13.3 12.5558 13.0863ZM13.7538 22.407L13.9888 22.3258V14.1725H18.08V22.3625L18.309 22.4465C20.8538 23.3816 22.5936 25.7698 22.7336 28.4581H9.2125C9.354 25.7181 11.14 23.3133 13.7538 22.407ZM15.973 35.5819C12.3555 35.5819 9.4 32.7293 9.2165 29.1568H22.7298C22.5461 32.7293 19.5906 35.5819 15.973 35.5819ZM40.2421 32.3101L34.2356 23.0576V14.063H34.6031C35.1344 14.063 35.5669 13.6308 35.5669 13.0993C35.5669 12.5678 35.1346 12.1355 34.6031 12.1355H29.4831C28.9518 12.1355 28.5193 12.568 28.5193 13.0993C28.5193 13.6305 28.9518 14.063 29.4831 14.063H29.8503V23.0578L23.8438 32.3103C23.5238 32.8036 23.5001 33.4063 23.7808 33.9228C24.0616 34.4394 24.5798 34.7479 25.1676 34.7479H38.9184C39.5061 34.7479 40.0246 34.4394 40.3051 33.9228C40.5856 33.4063 40.5621 32.8033 40.2421 32.3101ZM29.2181 13.0993C29.2181 12.953 29.3371 12.8343 29.4831 12.8343H34.6031C34.7491 12.8343 34.8681 12.9533 34.8681 13.0993C34.8681 13.2453 34.7491 13.3643 34.6031 13.3643H29.4831C29.3368 13.3643 29.2181 13.2453 29.2181 13.0993ZM30.5491 23.2643V14.063H33.5369V23.2646L35.5246 26.3268H28.5613L30.5491 23.2643ZM39.6911 33.5893C39.5349 33.8773 39.2459 34.0491 38.9184 34.0491H25.1676C24.8401 34.0491 24.5511 33.8773 24.3948 33.5893C24.2383 33.3016 24.2516 32.9656 24.4301 32.6906L28.1076 27.0253H35.9781L39.6559 32.6906C39.8344 32.9653 39.8476 33.3013 39.6911 33.5893Z'
      fill='black'
    />
  </svg>
)

export default Quimica
